import styled from "styled-components";

export const GeneralStyle = styled.div`
  width: 100%;
  height: 100%;
`;
